"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WeightingBar_meta_1 = require("../WeightingBar.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('span', WeightingBar_meta_1.WEIGHTING_BAR_CATEGORY_KEY, WeightingBar_meta_1.WEIGHTING_BAR_COMPONENT_KEY, ['weightingBlock']);